export interface RulesAddSubTileDataset {
  topEQs: string[];
  bottomAnswers: string[];
}

export const RULES_ADD_SUB_GPR: number[] = [
  1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 4, 4,
];

export const RULES_ADD_SUB_ROUNDS: number[] = [
  2, 2, 2, 4, 4, 4, 2, 2, 2, 4, 4, 4, 4,
];

export const RULES_ADD_SUB_START_SECONDS_DEFAULT: number[] = [0, 180, 135, 120];

// Indexed by gameFlag (0-12), matching the per-case overrides in nextProblem's
// caller switch.
export const RULES_ADD_SUB_START_SECONDS: number[][] = [
  [0, 60, 60, 60], // gameFlag 0
  [0, 60, 60, 60], // gameFlag 1
  [0, 60, 60, 60], // gameFlag 2
  [0, 75, 60, 45], // gameFlag 3
  [0, 75, 60, 45], // gameFlag 4
  [0, 0, 0, 0], // gameFlag 5
  [0, 60, 0, 0], // gameFlag 6
  [0, 60, 0, 0], // gameFlag 7
  [0, 60, 0, 0], // gameFlag 8
  [0, 90, 75, 60], // gameFlag 9
  [0, 90, 75, 60], // gameFlag 10
  [0, 0, 0, 0], // gameFlag 11
  [0, 0, 0, 0], // gameFlag 12
];

const flag4Layer1Round1Or3: RulesAddSubTileDataset = {
  topEQs: [
    '10 + 10',
    '10 + 20',
    '10 + 30',
    '10 + 40',
    '10 + 50',
    '10 + 60',
    '10 + 70',
    '10 + 80',
    '10 + 90',
    '20 + 20',
    '20 + 30',
    '20 + 40',
    '20 + 50',
    '20 + 60',
    '20 + 70',
    '20 + 80',
    '20 + 90',
    '30 + 30',
    '30 + 40',
    '30 + 50',
    '30 + 60',
    '30 + 70',
    '30 + 80',
    '30 + 90',
    '40 + 40',
    '40 + 50',
    '40 + 60',
    '40 + 70',
    '40 + 80',
    '40 + 90',
    '50 + 50',
    '50 + 60',
    '50 + 70',
    '50 + 80',
    '50 + 90',
    '60 + 60',
    '60 + 70',
    '60 + 80',
    '60 + 90',
    '70 + 70',
    '70 + 80',
    '70 + 90',
    '80 + 80',
    '80 + 90',
    '90 + 90',
  ],
  bottomAnswers: [
    '20',
    '30',
    '40',
    '50',
    '60',
    '70',
    '80',
    '90',
    '100',
    '40',
    '50',
    '60',
    '70',
    '80',
    '90',
    '100',
    '110',
    '60',
    '70',
    '80',
    '90',
    '100',
    '110',
    '120',
    '80',
    '90',
    '100',
    '110',
    '120',
    '130',
    '100',
    '110',
    '120',
    '130',
    '140',
    '120',
    '130',
    '140',
    '150',
    '140',
    '150',
    '160',
    '160',
    '170',
    '180',
  ],
};

const flag4Layer1Round2: RulesAddSubTileDataset = {
  topEQs: [
    '0 + 10',
    '20 + 0',
    '20 + 10',
    '0 + 30',
    '30 + 10',
    '30 + 20',
    '40 + 0',
    '40 + 10',
    '40 + 20',
    '40 + 30',
    '0 + 50',
    '50 + 10',
    '50 + 20',
    '50 + 30',
    '50 + 40',
    '60 + 0',
    '60 + 10',
    '60 + 20',
    '60 + 30',
    '60 + 40',
    '60 + 50',
    '0 + 70',
    '70 + 10',
    '70 + 20',
    '70 + 30',
    '70 + 40',
    '70 + 50',
    '70 + 60',
    '80 + 0',
    '80 + 10',
    '80 + 20',
    '80 + 30',
    '80 + 40',
    '80 + 50',
    '80 + 60',
    '80 + 70',
    '0 + 90',
    '90 + 10',
    '90 + 20',
    '90 + 30',
    '90 + 40',
    '90 + 50',
    '90 + 60',
    '90 + 70',
    '90 + 80',
  ],
  bottomAnswers: [
    '10',
    '20',
    '30',
    '30',
    '40',
    '50',
    '40',
    '50',
    '60',
    '70',
    '50',
    '60',
    '70',
    '80',
    '90',
    '60',
    '70',
    '80',
    '90',
    '100',
    '110',
    '70',
    '80',
    '90',
    '100',
    '110',
    '120',
    '130',
    '80',
    '90',
    '100',
    '110',
    '120',
    '130',
    '140',
    '150',
    '90',
    '100',
    '110',
    '120',
    '130',
    '140',
    '150',
    '160',
    '170',
  ],
};

// Round 4 uses the concatenation of the Round1/3 pool and the Round2 pool
// (verified against the original literal array byte-for-byte).
const flag4Layer1Round4: RulesAddSubTileDataset = {
  topEQs: [...flag4Layer1Round1Or3.topEQs, ...flag4Layer1Round2.topEQs],
  bottomAnswers: [
    ...flag4Layer1Round1Or3.bottomAnswers,
    ...flag4Layer1Round2.bottomAnswers,
  ],
};

export const RULES_ADD_SUB_DATA = {
  flag0: {
    layer1: {
      topEQs: [
        '0 + 0',
        '0 + 1',
        '0 + 2',
        '0 + 3',
        '0 + 4',
        '0 + 5',
        '0 + 6',
        '0 + 7',
        '0 + 8',
        '0 + 9',
        '1 + 0',
        '2 + 0',
        '3 + 0',
        '4 + 0',
        '5 + 0',
        '6 + 0',
        '7 + 0',
        '8 + 0',
        '9 + 0',
      ],
      bottomAnswers: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
      ],
    },
  },
  flag1: {
    layer1: {
      topEQs: [
        '1 + 1',
        '1 + 2',
        '1 + 3',
        '1 + 4',
        '1 + 5',
        '1 + 6',
        '1 + 7',
        '1 + 8',
        '1 + 9',
        '2 + 1',
        '3 + 1',
        '4 + 1',
        '5 + 1',
        '6 + 1',
        '7 + 1',
        '8 + 1',
        '9 + 1',
      ],
      bottomAnswers: [
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
      ],
    },
  },
  flag2: {
    layer1: {
      topEQs: [
        '2 + 3',
        '2 + 4',
        '2 + 5',
        '2 + 6',
        '2 + 7',
        '2 + 8',
        '3 + 4',
        '3 + 5',
        '3 + 6',
        '3 + 7',
        '4 + 5',
        '4 + 6',
      ],
      bottomAnswers: [
        '3 + 2',
        '4 + 2',
        '5 + 2',
        '6 + 2',
        '7 + 2',
        '8 + 2',
        '4 + 3',
        '5 + 3',
        '6 + 3',
        '7 + 3',
        '5 + 4',
        '6 + 4',
      ],
    },
  },
  flag3: {
    layer1: {
      topEQs: [
        '2 + 9',
        '3 + 9',
        '4 + 9',
        '5 + 9',
        '6 + 9',
        '7 + 9',
        '8 + 9',
        '9 + 9',
        '3 + 8',
        '4 + 8',
        '5 + 8',
        '6 + 8',
        '7 + 8',
        '8 + 8',
        '4 + 7',
        '5 + 7',
        '6 + 7',
        '5 + 6',
      ],
      bottomAnswers: [
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '11',
        '12',
        '13',
        '11',
      ],
    },
    layer3: {
      topEQs: [
        '9 + 8',
        '7 + 7',
        '8 + 7',
        '9 + 7',
        '6 + 6',
        '7 + 6',
        '8 + 6',
        '9 + 6',
        '6 + 5',
        '7 + 5',
        '8 + 5',
        '9 + 5',
        '7 + 4',
        '8 + 4',
        '9 + 4',
        '8 + 3',
        '9 + 3',
        '9 + 2',
      ],
      bottomAnswers: [
        '17',
        '14',
        '15',
        '16',
        '12',
        '13',
        '14',
        '15',
        '11',
        '12',
        '13',
        '14',
        '11',
        '12',
        '13',
        '11',
        '12',
        '11',
      ],
    },
  },
  flag4: {
    layer1Round1Or3: flag4Layer1Round1Or3,
    layer1Round2: flag4Layer1Round2,
    layer1Round4: flag4Layer1Round4,
  },
  flag6: {
    layer1: {
      topEQs: [
        '1 - 0',
        '1 - 1',
        '4 - 0',
        '3 - 3',
        '5 - 0',
        '6 - 6',
        '7 - 0',
        '9 - 9',
        '8 - 0',
      ],
      bottomAnswers: ['1', '0', '4', '0', '5', '0', '7', '0', '8'],
    },
    layer2: {
      topEQs: [
        '2 - 0',
        '4 - 4',
        '3 - 0',
        '2 - 2',
        '6 - 0',
        '5 - 5',
        '9 - 0',
        '7 - 7',
        '8 - 0',
      ],
      bottomAnswers: ['2', '0', '3', '0', '6', '0', '9', '0', '8'],
    },
  },
  flag7: {
    layer1: {
      topEQs: [
        '2 - 1',
        '3 - 1',
        '4 - 3',
        '5 - 1',
        '6 - 5',
        '6 - 1',
        '7 - 6',
        '8 - 1',
        '10 - 1',
      ],
      bottomAnswers: ['1', '2', '1', '4', '1', '5', '1', '7', '9'],
    },
    layer2: {
      topEQs: [
        '3 - 2',
        '4 - 1',
        '5 - 4',
        '7 - 1',
        '8 - 7',
        '9 - 1',
        '9 - 8',
        '10 - 1',
        '5 - 1',
      ],
      bottomAnswers: ['1', '3', '1', '6', '1', '8', '1', '9', '4'],
    },
  },
  flag8: {
    layer1: {
      topEQs: [
        '5 - 2 = xP5 - x = 2',
        '6 - 2 = xP6 - x = 2',
        '7 - 2 = xP7 - x = 2',
        '8 - 2 = xP8 - x = 2',
        '9 - 2 = xP9 - x = 2',
        '10 - 2 = xP10 - x = 2',
        '7 - 3 = xP7 - x = 3',
        '8 - 3 = xP8 - x = 3',
        '9 - 3 = xP9 - x = 3',
        '10 - 3 = xP10 - x = 3',
        '9 - 4 = xP9 - x = 4',
        '10 - 4 = xP10 - x = 4',
      ],
      bottomAnswers: [
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '4',
        '5',
        '6',
        '7',
        '5',
        '6',
      ],
    },
  },
  flag9: {
    layer1: {
      topEQs: [
        '11 - 8',
        '13 - 9',
        '12 - 8',
        '11 - 6',
        '14 - 9',
        '11 - 5',
        '15 - 9',
        '13 - 7',
        '16 - 9',
        '12 - 5',
        '13 - 6',
        '12 - 4',
        '13 - 5',
        '14 - 6',
        '11 - 2',
        '12 - 3',
        '13 - 4',
        '16 - 7',
      ],
      bottomAnswers: [
        '3',
        '4',
        '4',
        '5',
        '5',
        '6',
        '6',
        '6',
        '7',
        '7',
        '7',
        '8',
        '8',
        '8',
        '9',
        '9',
        '9',
        '9',
      ],
    },
    layer3: {
      topEQs: [
        '11 - 9',
        '12 - 9',
        '11 - 7',
        '12 - 7',
        '13 - 8',
        '12 - 6',
        '14 - 8',
        '15 - 8',
        '14 - 7',
        '11 - 4',
        '11 - 3',
        '15 - 7',
        '16 - 8',
        '17 - 9',
        '14 - 5',
        '15 - 6',
        '17 - 8',
        '18 - 9',
      ],
      bottomAnswers: [
        '2',
        '3',
        '4',
        '5',
        '5',
        '6',
        '6',
        '7',
        '7',
        '7',
        '8',
        '8',
        '8',
        '8',
        '9',
        '9',
        '9',
        '9',
      ],
    },
  },
  flag10: {
    layer1: {
      topEQs: [
        '90 - 10',
        '80 - 10',
        '80 - 20',
        '90 - 40',
        '70 - 20',
        '90 - 50',
        '70 - 30',
        '50 - 10',
        '70 - 40',
        '60 - 30',
        '80 - 60',
        '50 - 30',
        '40 - 20',
        '30 - 10',
        '60 - 50',
        '50 - 40',
        '30 - 20',
        '20 - 10',
      ],
      bottomAnswers: [
        '80',
        '70',
        '60',
        '50',
        '50',
        '40',
        '40',
        '40',
        '30',
        '30',
        '20',
        '20',
        '20',
        '20',
        '10',
        '10',
        '10',
        '10',
      ],
    },
    layer3: {
      topEQs: [
        '90 - 20',
        '90 - 30',
        '70 - 10',
        '60 - 10',
        '80 - 30',
        '80 - 40',
        '60 - 20',
        '50 - 20',
        '90 - 60',
        '80 - 50',
        '40 - 10',
        '70 - 50',
        '90 - 70',
        '60 - 40',
        '40 - 30',
        '80 - 70',
        '70 - 60',
        '90 - 80',
      ],
      bottomAnswers: [
        '70',
        '60',
        '60',
        '50',
        '50',
        '40',
        '40',
        '30',
        '30',
        '30',
        '30',
        '20',
        '20',
        '20',
        '10',
        '10',
        '10',
        '10',
      ],
    },
  },
} as const;
